<template>
  <b-form-radio
    v-model="selectedCard"
    :value="card.id"
    class="bordered-radio mb-3"
    name="credit-card"
    stacked
  >
    <div class="card-content-wrapper d-flex flex-column">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center card-main-info">

          <div class="card-icon-container">
            <VisaSVG v-if="card.type.toLowerCase() === 'visa'"/>
            <MastercardSVG v-if="card.type.toLowerCase() === 'mastercard'"/>
            <AmexSVG v-if="card.type.toLowerCase() === 'amex'"/>
            <AchSVG v-if="card.type.toLowerCase() === 'ach'"/>
          </div>

          <span class="ml-2 font-weight-bold card-number">
            xxxx {{ card.last_digits }}
          </span>

          <div
            v-if="card.expires"
            class="card-expiration-date ml-3">
          <span class="text-muted small">
            Exp. {{ card.expires }}
          </span>
          </div>
        </div>

        <div
          :id="'trash-card-'+card.id"
          v-if="showDeleteCard"
          class="cursor-pointer"
        >
          <TrashSVG
            @click.stop="card.card_is_use ? null : removeCreditCard()"
            class="trash-svg"
            :class="{ disabled: card.card_is_use }"
            alt="Remove Card"
          />
        </div>
        <b-tooltip
          v-if="card.card_is_use"
          :target="'trash-card-'+card.id"
          triggers="hover"
          custom-class="trash-card-tooltip"
        >
          Payment method is linked to active scheduled payments and cannot be deleted.
        </b-tooltip>
      </div>
    </div>
  </b-form-radio>
</template>

<script>
import store from "@/store"
import { BFormRadio, BTooltip } from 'bootstrap-vue'
import AchSVG from '@/assets/images/icons/ach.svg'
import AmexSVG from '@/assets/images/icons/amex.svg'
import VisaSVG from '@/assets/images/icons/visa.svg'
import MastercardSVG from '@/assets/images/icons/mastercard.svg'
import TrashSVG from '@/assets/images/icons/trash.svg'

export default {
  components: {
    BTooltip,
    BFormRadio,

    AchSVG,
    AmexSVG,
    VisaSVG,
    MastercardSVG,
    TrashSVG,
  },
  props: {
    card: {
      type: Object,
      default: () => {},
    },
    showDeleteCard: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selectedCard: {
      get: function () {
        return store.getters['cards/getSelectedCreditCard']
      },
      set: function (val) {
        store.commit('cards/SET_SELECTED_CREDIT_CARD', val)
      }
    },
  },
  methods: {
    async removeCreditCard() {
      if (this.card.card_is_use) {
        store.commit('cards/SET_CARD_FOR_REMOVE', this.card)
        this.$bvModal.show('replace-card')
      } else {
        store.commit('paymentPortal/SET_MODAL_LOADING_STATE', true)
        await store.dispatch('cards/deleteCreditCard', this.card.id)
        await store.dispatch('cards/fetchUserCards')
        store.commit('paymentPortal/SET_MODAL_LOADING_STATE', false)
      }
    },
  }
}
</script>

<style lang="scss">
@import 'src/assets/scss/colors/colors';

.card-icon-container {
  width: 50px;
  height: 25px;

  display: flex;
  align-items: center;
  justify-content: center;

  & > svg,
  & > img {
    max-height: 100%;
    max-width: 100%;
  }
}

.card-expiration-date span {
  white-space: nowrap;
}


.trash-svg {
  display: block;
  margin: 0;
  padding: 0;

  &.disabled {
    cursor: default;
    opacity: 0.5;
  }
}
.trash-card-tooltip .tooltip-inner {
  background-color: #F6E9EC !important;
  color: $primary !important;
  border-radius: 15px;
  padding: 13px 19px;
  max-width: 300px;
}
.trash-card-tooltip.bs-tooltip-top .arrow::before {
  border-top-color: #F6E9EC !important;
}
</style>